import styled from "styled-components";

export const Banner = styled.div`
    position: fixed;
    top: 0;
    width: 100dvw;
    height: 100dvh;
    display: none;
    justify-content: center;
    align-items: center;
    background-color: white;
    z-index: 9999999; 
    #close-intro-btn {
      position: absolute;
      width: 50px;
      height: 50px;
      top: 15px;
      right: 25px;
      cursor: pointer;
      z-index: 99999;
    }
    #div-gpt-ad-intro div > iframe:first-of-type {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 999999;
    }
    #close-intro-btn {
      background-color: hsl(349, 100%, 42%, .8);
      border: none;
      border-radius: 10px;
      color: white;
      padding: 10px 15px;
      font-family: system-ui;
      font-size: 20px;
      font-weight: 600;
      width: fit-content;
    }
`